"use client"

import dynamic from "next/dynamic"
import { ThemeProvider } from "next-themes"
import { Suspense } from "react"

// Dynamically import heavy components to reduce initial bundle size
const Analytics = dynamic(() => import("@vercel/analytics/next").then(mod => mod.Analytics), { ssr: false })

const Toaster = dynamic(() => import("sonner").then(mod => mod.Toaster), { ssr: false })

const NotificationInitializer = dynamic(
	() => import("@/components/notification-initializer").then(mod => mod.NotificationInitializer),
	{ ssr: false }
)

export function Providers({ children }: { children: React.ReactNode }) {
	return (
		<ThemeProvider attribute="class" defaultTheme="light" enableSystem themes={["light", "dark", "system"]}>
			{children}
			<Suspense fallback={null}>
				<Analytics />
				<Toaster />
				<NotificationInitializer />
			</Suspense>
		</ThemeProvider>
	)
}
